import * as fetcher from "../fetcher";
import { mutateWithStartKey } from "../mutateWithStartKey";

interface BookFollowUpResponse {
  orderNumber: string;
}

export const bookFollowUpAppointment = async (
  appointmentOrderNumber?: string,
  followUpAppointmentId?: number,
  service?: string
): Promise<BookFollowUpResponse | null> => {
  if (!appointmentOrderNumber || !followUpAppointmentId) {
    return null;
  }

  const requestBody: {
    appointmentOrderNumber: string;
    followUpAppointmentId: number;
    service?: string;
  } = {
    appointmentOrderNumber,
    followUpAppointmentId,
  };

  if (service) {
    requestBody.service = service;
  }

  const res = await fetcher.core.post<BookFollowUpResponse, false>(
    `/appointments/followup`,
    requestBody
  );

  mutateWithStartKey("/opportunities/appointments");

  return res;
};
